/**
 * 订单管理 挂号统计
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/base/index' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>挂号详情</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
         <el-input size="small" v-model="formInline.department_name" placeholder="输入科室名称"></el-input>
      </el-form-item>


     <!-- <el-form-item>
          <el-date-picker
            v-model="formInline.date"
            value-format="timestamp"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            >
          </el-date-picker>
      </el-form-item> -->
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-refresh-left" @click="formReset()">重置</el-button>
      </el-form-item>

    </el-form>
    <!--列表  :summary-method="getSummaries"-->

    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" :summary-method="getSummaries"
  show-summary style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>

      <el-table-column prop="tj_date" align="center"label="挂号日期" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="department_name" align="center" label="挂号科室" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="department_id"
       align="center" label="科室ID" show-summary="false" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="dt_gh_num"
      align="center" label="当日挂号数" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="yy_gh_num"
      align="center" label="预约挂号数" width="100" show-overflow-tooltip>
      </el-table-column>

      <!-- <el-table-column prop="today_count_money" align="center" label="当日挂号金额" width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable prop="yy_count_money" label="预约挂号金额" width="140" show-overflow-tooltip>
      </el-table-column> -->

    </el-table>


 <!-- <div class="echart" id="mychart" :style="myChartStyle"></div> -->
<div id="myChart3" style="display: none;"></div>

  </div>
</template>

<script>
// import { OrderList, orderToHis,wxRefund } from '../../api/payMG'
import { ghjl,ghjldetail} from '../../api/baseset'
import Pagination from '../../components/Pagination'
import * as echarts from "echarts";

export default {
  data() {
    return {
      loading: false,
      refundVisible: false,

      formInline: {
        page: 1,
        limit: 10,
        department_name:'',
        tj_date:''
      },
      listData: [], //订单数据
      department_name:'',
      today_data:'',
      yy_data:'',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
       myChart: {},
       pieData: [],
      pieName: [],
      tdate:'',
       myChartStyle: { float: "left", width: "100%", height: "400px" } //图表样式


    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {

    // #this.getdata(this.formInline)

  },
  mounted() {
     this.formInline.tj_date = this.$route.params.date;
      console.log(this.$route.params.date)
     this.getdata();
  // this.getsjtjs();
   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
     // 房间号的合计去掉
      getSummaries (param) {
       const { columns, data } = param
       const sums = []
       columns.forEach((column, index) => {
       if (index === 0) {
        sums[index] = '总计'
       } else if (index === 5 || index === 4) {
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
        sums[index] = values.reduce((prev, curr) => {
         const value = Number(curr)
         if (!isNaN(value)) {
         return prev + curr
         } else {
         return prev
         }
        }, 0)
        } else {
        sums[index] = 'N/A'
        }
       } else {
        sums[index] = '--'
       }
       })
       return sums
      },
    // 获取公司列表
    getdata() {
      this.loading = true
      let param = this.formInline
      console.log(param)
      //eturn
        ghjldetail(param)
         .then(res => {
           console.log(res)
           this.loading = false
           if (res.success == false) {
             this.$message({
               type: 'info',
               message: res.msg
             })
           } else {

             this.listData = res.data



           }
         })
         .catch(err => {
           this.loading = false
           this.$message.error('数据加载失败，请稍后再试！')
         })
    },

    // 重置搜索
    formReset() {
       this.formInline = {
        page: 1,
        limit: 50
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    detail(id){
        console.log(id)
    },
    // 搜索事件
    search() {
      this.formInline.page = 1
      this.formInline.limit = 50
      console.log(this.formInline)
      this.getdata(this.formInline)
    },


  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.tubiao{
  width: 35%;
  height: 300px;
  border: solid 1px red;
  float: left;
}
#myChart3{
  background-color: white !important;
  margin-top:30px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/charts/ghtjdetail.vue